import { render, staticRenderFns } from "./ClickableCalcStatChip.vue?vue&type=template&id=33702bd4&scoped=true"
import script from "./ClickableCalcStatChip.vue?vue&type=script&lang=js"
export * from "./ClickableCalcStatChip.vue?vue&type=script&lang=js"
import style0 from "./ClickableCalcStatChip.vue?vue&type=style&index=0&id=33702bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33702bd4",
  null
  
)

export default component.exports